<template>
  <section class="c-section c-section--teacher-profile">
    <b-skeleton-wrapper :loading="contextLoading">
      <template #loading>
        <div class="container-fluid">
          <b-card class="mb-5">
            <b-skeleton animation="wave" width="100%" height="300px"></b-skeleton>
          </b-card>
        </div>
        <div class="container">
          <section class="py-5">
            <div class="row gy-4">
              <div class="col-12 col-lg-8">
                <div class="row gy-3">
                  <div class="col-12">
                    <b-skeleton width="80%" height="30px"></b-skeleton>
                  </div>
                  <div class="col-12">
                    <b-skeleton width="60%" height="20px"></b-skeleton>
                  </div>
                  <div class="col-12">
                    <b-skeleton width="80%" height="20px"></b-skeleton>
                  </div>
                  <div class="col-12">
                    <b-skeleton width="70%" height="20px"></b-skeleton>
                  </div>
                </div>
              </div>
              <div class="col-md-4 d-none d-lg-block">
                <div class="row gy-3">
                  <div class="col-12">
                    <b-skeleton height="60px"></b-skeleton>
                  </div>
                  <div class="col-12">
                    <b-skeleton height="20px"></b-skeleton>
                  </div>
                  <div class="col-12">
                    <b-skeleton height="20px"></b-skeleton>
                  </div>
                  <div class="col-12">
                    <b-skeleton height="20px"></b-skeleton>
                  </div>
                  <div class="col-12">
                    <b-skeleton height="20px"></b-skeleton>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </template>

      <div v-if="context.fullname" class="c-banner">
        <div class="container">
          <div class="position-relative">
            <div class="c-avatar-teacher d-md-flex">
              <figure class="c-avatar-teacher__figure mb-2 mb-md-0">
                <img
                  :src="context.avatar.url"
                  :alt="context.fullname"
                  class="w-100 h-100 of--cover"
                />
              </figure>
              <div>
                <h2 class="fs-30 gray-lightx w-sbold text-center text-md-start">
                  {{context.fullname}}
                </h2>
                <p class="gray-lightx fs-16 w-regular text-center text-md-start mb-4">
                  {{context.job}}
                </p>
                <div class="d-flex justify-content-center justify-content-md-start">
                  <p
                    class="fs-14 gray-lightx w-regular me-3 d-flex
                      align-items-center mb-4 mb-md-5"
                  >
                    <span class="fs-18 d-flex me-2">
                      <Icon icon="ph:presentation-chart-light"/>
                    </span>
                    {{context.courses.length}} cursos
                  </p>
                  <p class="fs-14 gray-lightx w-regular d-flex align-items-center mb-4 mb-md-5">
                    <span class="fs-18 d-flex me-2">
                      <Icon icon="mdi:user-outline"/>
                    </span>
                    {{context.students}} alumnos
                  </p>
                </div>
                <div class="d-flex justify-content-center justify-content-md-start">
                  <div class="c-social c-social--primary">
                    <a
                      v-if="context.social_media.facebook"
                      :href="context.social_media.facebook"
                      target="_blank"
                      class="c-social__icon"
                    >
                      <Icon icon="cib:facebook-f" />
                    </a>
                    <a
                      v-if="context.social_media.instagram"
                      :href="context.social_media.instagram"
                      target="_blank"
                      class="c-social__icon"
                    >
                      <Icon icon="akar-icons:instagram-fill" />
                    </a>
                    <a
                      v-if="context.social_media.twitter"
                      :href="context.social_media.twitter"
                      target="_blank"
                      class="c-social__icon"
                    >
                      <Icon icon="akar-icons:twitter-fill" />
                    </a>
                    <a
                      v-if="context.social_media.whatsapp"
                      :href="context.social_media.whatsapp"
                      target="_blank"
                      class="c-social__icon"
                    >
                      <Icon icon="akar-icons:whatsapp-fill" />
                    </a>
                    <a
                      v-if="context.social_media.linkedin"
                      :href="context.social_media.linkedin"
                      target="_blank"
                      class="c-social__icon"
                    >
                      <Icon icon="akar-icons:linkedin-fill" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="c-medialuna">
              <img src="@/assets/img/semicircle.png" alt="" class="w-100 h-100 of--cover">
            </div>
            <div class="c-ganchouno d-none d-md-block">
              <img src="@/assets/img/gancho.png" alt="" class="w-100 h-100 of--cover">
              <div class="c-capa"></div>
            </div>
            <div class="c-ganchodos d-none d-md-block">
              <img src="@/assets/img/gancho.png" alt="" class="w-100 h-100 of--cover">
              <div class="c-capa c-capa--doble d-none d-md-block"></div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="context.fullname" class="container">
        <div class="py-5">
          <div class="row gy-5">
            <div class="col-12 col-lg-8">
              <div v-html="context.summary"></div>
            </div>
            <div class="col-12 col-lg-4">
              <h2 class="fs-25 w-sbold sec-medium">
                Cursos impartidos
              </h2>
              <div class="c-wr mb-5"></div>

              <router-link
                v-for="(course, icourse) of context.courses"
                :key="`course-${icourse}`"
                :to="`/curso/${course.slug}`"
                class="curses-taught mb-5"
              >
                <figure class="curses-taught__figure me-3">
                  <img
                    :src="course.thumbnail"
                    :alt="course.title"
                    class="w-100 h-100 of--cover"
                  />
                </figure>

                <div>
                  <h2 class="fs-16 w-sbold sec-medium">
                    {{course.title}}
                  </h2>
                  <p class="d-flex align-items-center fs-14 pri-color w-regular">
                    <span class="d-flex me-2 fs-18">
                      <Icon icon="mdi-light:thumb-up"/>
                    </span>
                    <span>
                      {{course.likes}}
                    </span>
                  </p>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </b-skeleton-wrapper>
  </section>
</template>

<script>
export default {
  data() {
    return {
      context: {},
      contextLoading: true,
    };
  },
  created() {
    this.getFullContext({ type: 'user', slug: this.$route.params.specialist_slug });
  },
  watch: {
    contextLoading(value) {
      if (!value) {
        document.title = `${this.context.fullname} - Agro Club`;
      }
    },
  },
};
</script>
